import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, catchError, concat, debounce, Observable, of, Subject, switchMap, tap, timer } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { TEXT_FIELDS } from '../../customer-service.service';
import { ManageTemplateComponent } from '../../manage-template/manage-template.component';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';

@Component({
  selector: 'app-workspace-details',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent, NgSelectModule, FormsModule, CommonSkeletonComponent],
  templateUrl: './workspace-details.component.html',
  styleUrls: ['./workspace-details.component.scss']
})
export class WorkspaceDetailsComponent implements OnInit , OnDestroy {

  fields: Array<Partial<TEXT_FIELDS>>;
  columns: Array<Partial<TEXT_FIELDS>>;
  teamDetails !: any;
  userDatas = new BehaviorSubject([]);
  teamId: any;
  focused : boolean = true;
  @ViewChild('ownerSelect') ownerSelect: NgSelectComponent;
  payload = {
    limit: 10,
    page: 0,
    searchContent : null,
    status : null,
    searchAfterKey : null
  };
  userPayload = {
    businessId : null,
    searchContent : null,
    email : null,
    searchAfterKey : null,
    statusList:['ACTIVE','INACTIVE','BLOCKED'],
    type:'TEAM_WORKSPACES',
    groupType: "MANAGE"

  };
  prevSearchAfterKey : any;
  employeePrevSearchAfterKey : Array<any> = [];
  stopScroll : boolean = false;
  businessId: any;
  employeesList = new BehaviorSubject([]);
  employeeStopScroll: boolean = false;
  businessEmail: any;
  searchSubject = new Subject();
  tempSelectedEmployee: any;
  /** The owner row ng-select must always be able to resolve. Kept separate from
   *  `teamDetails` so it stays correct mid-transfer, when `adminUserData` is
   *  still the old owner while `teamsOwnerId` is already the new one. */
  ownerOption: any;
  /** Owner the user just transferred to, kept until `findTeamMembers` returns the
   *  same owner. The save is only queued (Kafka) and the read comes from
   *  Elasticsearch, so the refetch 1s later can still carry the old owner. */
  private pendingOwner: any = null;
  private ownerRecheckCount = 0;
  private ownerRecheckTimer: any;
  private readonly OWNER_RECHECK_MAX = 4;
  private readonly OWNER_RECHECK_DELAY = 1500;

  constructor(private API: ApiService, private aRoute: ActivatedRoute,private util : UtilService
  ) {

    this.aRoute.queryParams.subscribe(res => {
      this.teamId = res.teamId;
      this.businessId = res.id;
      this.businessEmail = res.businessEmail;
    });

    this.fields = [
      { label: "Workspace Name", key: 'teamName',
        disabled : false ,
        validate : true ,
        required : true,
        min : 5,
        max : 30,
        minText : 'Minimum 5 chars is required',
        requiredText : 'Workspace name is required',
        maxText : 'Maximum 30 chars is allowed',
        pattern : '^[a-zA-Z ]*$',
        patternText : 'Must contain only alphabets',

      },
      { label: "Owner", key: 'owner' , dropdownView : true  , disabled : false},
      { label: "Members", key: 'members' , disabled : true},
    ];

    this.columns = [
      { label: 'Members', key: 'fullName' },
      { label: 'Email', key: 'email' },
      { label: 'Title', key: 'title' },
    ];

  }

  ngOnDestroy(): void {
    clearTimeout(this.ownerRecheckTimer);
    this.pendingOwner = null;
    this.searchSubject.unsubscribe();
    this.employeesList.unsubscribe();
    this.userDatas.unsubscribe();
  }


  ngOnInit(): void {

    if (this.teamId) {
      this.getTeam();
      this.onsearchEmployee();
    }
  }

  onsearchEmployee() {

    const data = concat(
      of([]), // default items
      this.searchSubject.pipe(
        // `null` is ng-select's "search term cleared" signal (✕ / close with a
        // term typed). It used to be filtered out, which left the list stuck on
        // the last search results. Let it through so the list resets to the
        // unfiltered first page — immediately, while real typing keeps the
        // 800ms debounce. switchMap drops any in-flight search either way.
        debounce(term => timer(term ? 800 : 0)),
        tap(() => this.loading = true),
        switchMap(term => {
          return this.searchEmployees(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.loading = false),

          )
        })
      )
    );

    data.subscribe(res=>{
      if(res.code === AppSettings.SUCESS_CODE){
        this.employeesList.next(this.withOwner(res.data.customerUserAllocationList));
      }
    });

  }

  searchEmployees(res: any) {
    this.userPayload = {
      ...this.userPayload,
      searchAfterKey : null,
      searchContent : res || null
    };
    this.employeeStopScroll = false;
    this.employeePrevSearchAfterKey = [];
    this.notFound = "No results found";
    this.employeesList.next(this.withOwner([]));
    return this.getCustomerUsersList(this.userPayload);
  }

  originalEmployeesList: any[] = [];
  loading = false;
  getEmployees() {
    this.userPayload.businessId = this.businessId;
    this.userPayload.email = this.businessEmail;

    this.util.startLoader()
    this.getCustomerUsersList(this.userPayload).subscribe(response=>{
      this.util.stopLoader()
      if (response.code === AppSettings.SUCESS_CODE) {
        const users = response.data.customerUserAllocationList;

           let searchKey = response.data.searchAfterKey;

          if (users) {
            const current = users;
            const exist = this.employeesList.getValue();
            const uniqueUsers = [...current , ...exist].filter((item, index, self) =>
              index === self.findIndex((t) => t.userId === item.userId)
            );
            this.originalEmployeesList = [...uniqueUsers];
            this.employeesList.next(this.withOwner(uniqueUsers));
          }
          if ((users && users.length === 0) || JSON.stringify(this.employeePrevSearchAfterKey) === JSON.stringify(searchKey)) {
            this.employeeStopScroll = true;
            this.notFound = this.employeesList.getValue().length ? "you reached the bottom" : "No results found";
          }
          this.employeePrevSearchAfterKey =  searchKey;
        }
    });
  }

  getCustomerUsersList(payload: Object): Observable<any> {
    return this.API.create('subscription/findEmployeeBenefitsAllocation', payload);
  }

  /** Ensures the current workspace owner is present in the ng-select items so
   *  the selected pill (bindValue=userId) can resolve its label. During a
   *  search the owner shows only if the API returned them — unless the model
   *  points at the owner right now: a model write with the row missing makes
   *  ng-select render a label-less pill.
   *  While the field is cleared the owner row is disabled so re-picking the
   *  same owner can't trigger the transfer popup. It must NOT stay disabled
   *  while selected: ng-select's ✕ keeps disabled items selected. */
  private withOwner(users: any[]): any[] {
    const owner = this.ownerOption;
    const ownerId = owner?.userId;
    let list = users || [];
    const mustResolve = this.selectedEmployee != null && this.selectedEmployee === ownerId;
    if (owner && (mustResolve || !this.userPayload.searchContent)
      && !list.some(u => u.userId === ownerId)) {
      list = [owner, ...list];
    }
    const disableOwner = this.selectedEmployee == null;
    const mapped = list.map(u => u.userId === ownerId ? { ...u, disabled: disableOwner } : u);

    // pin the current owner to the top
    const pinned = mapped.filter(u => u.userId === ownerId);
    const rest = mapped.filter(u => u.userId !== ownerId);
    return [...pinned, ...rest];
  }

  private refreshOwnerState() {
    this.employeesList.next(this.withOwner(this.employeesList.getValue()));
  }

  /** The backend occasionally returns an owner row with no fullName - the item
   *  then resolves but the pill still renders blank. Fall back to the email. */
  private asOwnerOption(user: any): any {
    if (!user) {
      return null;
    }
    return user.fullName?.trim() ? user : { ...user, fullName: user.email || user.fullName };
  }

  /** Reads only the team header until it reports the owner that was just saved,
   *  then does one normal reload so the members table (crown, count) is current.
   *  Gives up after OWNER_RECHECK_MAX tries and accepts what the server says. */
  private scheduleOwnerRecheck() {
    clearTimeout(this.ownerRecheckTimer);
    this.ownerRecheckTimer = setTimeout(() => {
      if (!this.pendingOwner) return;
      this.API.create('teams/findTeamMembers', { teamId: this.teamId, businessId : this.businessId, ...this.payload, searchAfterKey : null }).subscribe(response => {
        if (!this.pendingOwner || response.code !== AppSettings.SUCESS_CODE) return;
        const caughtUp = response.data.teams?.teamsOwnerId === this.pendingOwner.userId;
        if (!caughtUp && ++this.ownerRecheckCount < this.OWNER_RECHECK_MAX) {
          this.scheduleOwnerRecheck();
          return;
        }
        this.pendingOwner = null;
        this.payload.searchAfterKey = null;
        this.prevSearchAfterKey = null;
        this.stopScroll = false;
        this.userPayload.searchAfterKey = null;
        this.employeePrevSearchAfterKey = null;
        this.employeeStopScroll = false;
        this.userDatas.next([]);
        this.getTeam();
      });
    }, this.OWNER_RECHECK_DELAY);
  }

  updateTeam(event, ownerTransfer?: { rollback: () => void }) {
    let arr: any[] = [];
    arr.push(event);
    const updatedArray = arr.map(obj=>{
      const {members, ...rest} = obj;
      return rest;
    });
    this.API.create('business/manageTeams', updatedArray).pipe(
      tap({ error: () => ownerTransfer?.rollback() })
    ).subscribe(res => {
      if (ownerTransfer) {
        if (res && res.code === '00000') {
          this.pendingOwner = this.ownerOption;
          this.ownerRecheckCount = 0;
        } else {
          ownerTransfer.rollback();
        }
      }
      if (res && res.code === '00000') {
        this.teamDetails = event;
        Swal.fire({
          icon : "success",
          title : "Workspace Updated!",
          text : "Workspace updated successfully",
          showConfirmButton: false,
          allowOutsideClick : false,
          timer: 2000,
        })
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.payload.searchContent='';
          this.userPayload.searchContent='';
          this.userPayload.searchAfterKey = null;
          this.employeePrevSearchAfterKey = null;
          this.employeeStopScroll = false;
          this.userDatas.next([]);
          this.getTeam();
      }, 1000);
      }
      this.util.stopLoader();
    });
  }

  updateTeamMembers(members: any) {

    const userData = members.value;
    let data = {
      teamId: this.teamId,
      userId: userData.userId,
      status: userData.connectionStatus
    }

    if(members.checked){
       this.updateMembersBulk(data);
    }
    else{
      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick : false,
        title : "Inactive Member From Workspace",
        text : `Are you sure you want to inactive ${userData.fullName}?`
      }).then(res=>{

        const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));

        if(res.isConfirmed){
          this.updateMembersBulk(data);
        }
        else{
          updatedData.forEach(res=>{
            if(res.userId === userData.userId){
              res.connectionStatus = "ACTIVE";
            }
          });
          this.userDatas.next(updatedData);
        }

      });

    }

  }


  updateMembersBulk(data){
    this.util.startLoader();
    this.API.create('business/manageTeamMembers', [data]).subscribe(res => {
      if (res && res.code === '00000') {
        this.util.stopLoader();
        Swal.fire({
          icon : "success",
          title : 'Member Updated!',
          text : "Member updated successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          this.payload.searchAfterKey = null;
          this.prevSearchAfterKey = null;
          this.stopScroll = false;
          this.userPayload.searchAfterKey = null;
          this.employeePrevSearchAfterKey = null;
          this.employeeStopScroll = false;
          this.userDatas.next([]);
          this.getTeam();
      }, 1000);
      }
    });
  }

  getTeam() {

    this.API.create('teams/findTeamMembers', { teamId: this.teamId, businessId : this.businessId,  ...this.payload }).subscribe(response => {

      if (response.code === AppSettings.SUCESS_CODE) {
        const users = response.data.userDetails;
        const searchKey = response.data.searchAfterKey;

        if (users) {
          const current = users;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(users != null && (users.length === 0 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;
        }
        this.prevSearchAfterKey =  searchKey;

        let { adminUserData, ...rest } = response.data.teams;
        if (this.pendingOwner) {
          if (rest.teamsOwnerId === this.pendingOwner.userId) {
            clearTimeout(this.ownerRecheckTimer);
            this.pendingOwner = null;
          } else {
            // Stale read — keep the owner that was just saved and re-check quietly.
            adminUserData = this.pendingOwner;
            rest = { ...rest, teamsOwnerId : this.pendingOwner.userId };
            this.scheduleOwnerRecheck();
          }
        }
        let data = {
          ...rest,
          owner: adminUserData.fullName ,
          members: rest.memberCnt,
          userId : adminUserData.userId,
          adminUserData : adminUserData
        }
        this.teamDetails = data;
        this.ownerOption = this.asOwnerOption(adminUserData);
        this.selectedEmployee = this.ownerOption.userId;
        this.tempSelectedEmployee = this.ownerOption.userId;
        this.employeesList.next(this.withOwner([]));
        this.getEmployees();

      }

    });

  }


  onSearch(value , obj : WorkspaceDetailsComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getTeam();
  }

  onFilter(data , obj : WorkspaceDetailsComponent){
    console.log("FILTERED DATA" , data);
    obj.payload = {
      ...obj.payload,
      status : data.status,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);

    obj.getTeam();
  }

  onScroll(obj : WorkspaceDetailsComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getTeam();
    }
  }

  selectedEmployee
  // searchFn(compo : WorkspaceDetailsComponent , val){
  //   compo.searchSubject.next(val.searchTerm);
  // }

  originalOwner:any
  onChange(){
    // Clearing the select (✕) also fires change with an empty model — no
    // transfer yet, stay open and wait for the user to pick a new owner.
    if (this.selectedEmployee == null) return;
    this.originalOwner = this.ownerOption?.userId;
    const userData = this.employeesList.getValue().find(x => x.userId === this.selectedEmployee);

    SWAL_WITH_BUTTONS.fire({
      icon :"warning",
      title : "Transfer Workspace Admin Rights!",
      text : "Are you sure you want to transfer the workspace owner to " + userData.fullName,
      confirmButtonText : "Yes",
      cancelButtonText : "No",
      showConfirmButton: true,
      showCancelButton: true,
      reverseButtons: true,
    }).then(res=>{

      if(res.isConfirmed){
        // Keep the pill resolvable through the ~1s gap before getTeam() refetches
        // and replaces adminUserData with the new owner.
        const previousOwner = this.ownerOption;
        const previousTeam = this.teamDetails;
        this.ownerOption = this.asOwnerOption(userData);
        this.teamDetails = {
          ...this.teamDetails,
          teamsOwnerId : this.selectedEmployee
        };
        this.refreshOwnerState();
        this.updateTeam(this.teamDetails, {
          // Save failed — put the real owner back instead of leaving the unsaved pick.
          rollback : () => {
            this.ownerOption = previousOwner;
            this.teamDetails = previousTeam;
            this.selectedEmployee = previousOwner?.userId;
            this.refreshOwnerState();
          }
        });
      }
      else{
        // Model first so withOwner() sees it pointing at the owner and keeps the
        // owner row even when `originalEmployeesList` is a searched or scrolled
        // page that no longer holds them.
        this.selectedEmployee = this.originalOwner;
        this.employeesList.next(this.withOwner([...this.originalEmployeesList]));
      }


    });
  }

  onFocus(){
    this.focused = false;


  }

  notFound = "No results found";
  /** ✕ on the Owner select: ng-select 6.1's clear handler empties the model and
   *  calls focus() on its search input, but never opens the list. Worse, a
   *  global rule (`.ng-select-single .ng-has-value … .ng-input { display:none }`)
   *  still hides that input at this instant — the chip hasn't been re-rendered
   *  away yet — so focus() is a silent no-op and the field ends up idle.
   *  Open the list now, and focus once change detection has revealed the input. */
  onClear(){
    this.refreshOwnerState();
    this.ownerSelect?.open();
    setTimeout(() => this.ownerSelect?.focus());
  }

  onClose(){
    this.focused = true;
    // Closed after clearing without picking a replacement — snap back to the
    // current owner so the field is never left blank (no API call involved).
    if (this.selectedEmployee == null && this.teamDetails?.teamsOwnerId) {
      this.selectedEmployee = this.teamDetails.teamsOwnerId;
      this.refreshOwnerState();
    }
  }

  onScrollEmployee(){
    if(!this.employeeStopScroll){
      this.userPayload = {
        ...this.userPayload,
        searchAfterKey : (this.employeePrevSearchAfterKey && this.employeePrevSearchAfterKey.length === 0) ? null : this.employeePrevSearchAfterKey
      }
      this.getEmployees();
    }
}


}
